import React, { Component } from "react";
import PropTypes from "prop-types";
import fordStyles from "./SubNav.module.scss";
import lincolnStyles from "./SubNav-Lincoln.module.scss";
import SubNavDropdown from "./SubNavDropdown";
import HasPermissionTo from "../../common/HasPermissionTo";
import SubNavTabs from "./SubNavTabs";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import UpperCaseText from "../../utils/UpperCaseText";
import EMPSelectField from "../components/EMPSelectField/EMPSelectField";

class SubNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleTabsCount: 100,
      windowWidth: globalThis.innerWidth,
    };

    this.tabletWindowWidth = 1024;
    this.onboardedDealers =
      UpperCaseText(this.props.user.userType) === "DEALER"
        ? this.props.user.getOnboardedDealerGroup()
        : [];
  }

  componentDidMount() {
    if (this.props.tabs) {
      globalThis.addEventListener("resize", this.handleWindowResize);
      this.getVisibleTabsCount();
    }
  }

  componentWillUnmount() {
    if (this.props.tabs) {
      globalThis.removeEventListener("resize", this.handleWindowResize);
    }
  }

  handleWindowResize = () => {
    this.setState(
      {
        windowWidth: globalThis.innerWidth,
        visibleTabsCount: 100,
      },
      this.getVisibleTabsCount
    );
  };

  inViewPort = (boundary, divPaddingRight, windowWidth) => {
    return boundary.left >= 0 && boundary.right + divPaddingRight < windowWidth;
  };

  getVisibleTabsCount = () => {
    if (this.state.windowWidth <= this.tabletWindowWidth) {
      return;
    }

    let visibleTabs = 0;
    let notVisibleTabsFlag = false;
    let elemRightBoundary = 0;

    const windowWidth = this.state.windowWidth;
    const divPaddingRightPercent = 6;
    const divPaddingRight = windowWidth * (divPaddingRightPercent / 100);
    const moreTabWidth = 172;

    this.props.tabs.forEach((item) => {
      if (notVisibleTabsFlag) {
        return;
      }

      const elem = document.getElementById(`tab${item.id}`);

      if (!elem) {
        return;
      }

      const boundary = elem.getBoundingClientRect();

      if (this.inViewPort(boundary, divPaddingRight, windowWidth)) {
        visibleTabs += 1;
      } else {
        // checking if there is enough space for More Tab.
        // Otherwise, reduce one Visible Tab to make space.
        if (elemRightBoundary + divPaddingRight + moreTabWidth >= windowWidth) {
          visibleTabs -= 1;
        }

        notVisibleTabsFlag = true;
      }

      elemRightBoundary = boundary.right;
    });

    this.setState({ visibleTabsCount: visibleTabs });
  };

  renderDropdown = (isFordBrand, styles) => {
    if (this.props.restrictDropdown) {
      return null;
    }

    if (this.props.showCustomDropdown) {
      return (
        <div className={styles.container}>
          <EMPSelectField {...this.props} isFordBrand={isFordBrand} />
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <HasPermissionTo
          perform={["AllCMA:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={this.onboardedDealers.length > 1}
          render={() => <SubNavDropdown {...this.props} />}
        />
      </div>
    );
  };

  render() {
    const isFordBrand = IS_FORD_BRAND(this.props.user.brand);
    const styles = isFordBrand ? fordStyles : lincolnStyles;

    return (
      <div className={styles.subNav}>
        {this.renderDropdown(isFordBrand, styles)}

        <SubNavTabs
          visibleTabsCount={this.state.visibleTabsCount}
          isFordBrand={isFordBrand}
          {...this.props}
        />
      </div>
    );
  }
}

SubNav.propTypes = {
  restrictDropdown: PropTypes.bool,
  showCustomDropdown: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  user: PropTypes.shape({
    brand: PropTypes.string,
    getOnboardedDealerGroup: PropTypes.func.isRequired,
    permissions: PropTypes.shape({
      rolePermissions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }).isRequired,
    userType: PropTypes.string,
  }).isRequired,
};

SubNav.defaultProps = {
  restrictDropdown: false,
  showCustomDropdown: false,
  tabs: [],
};

export default withTranslation("emp")(SubNav);
